/** Return the Ethiopian subscriber number without a country or trunk prefix. */
export function normalizeEthiopianSubscriberNumber(input: string): string {
  let digits = input.replace(/\D/g, "");
  if (digits.startsWith("251")) digits = digits.slice(3);
  if (digits.startsWith("0")) digits = digits.slice(1);
  return digits;
}
